import { FC } from "react";
import { theme } from "src/theme";
import { Box } from "@otrium/core";
import { Trans } from "@lingui/macro";
import { ContentMobileFullscreen } from "src/atoms/Content";
import { Button } from "src/atoms/Button";
import { Carousel } from "src/molecules/Carousel";
import useAlgoliaProductsCarousel from "src/hooks/useAlgoliaProductsCarousel";
import { CarouselType } from "src/types/AlgoliaProductsCarousel.d";
import styled from "@emotion/styled";

const Image = styled("img")`
  max-height: 210px;

  @media (min-width: ${({ theme }) => theme.breakpoints[3]}) {
    max-height: 255px;
  }
`;

interface Props {
  brandSlug: string;
}

const SalesLandingCarousel: FC<Props> = ({ brandSlug }) => {
  const { products } = useAlgoliaProductsCarousel({
    carouselType: CarouselType.POPULAR_PRODUCTS,
    hitsPerPage: 12,
    brandSlug,
  });

  const baseUrl = window.location.origin;

  return products?.results?.length ? (
    <Box
      backgroundColor={theme.colors.tone.white}
      py={["48px", "48px", "48px", "96px"]}
    >
      <ContentMobileFullscreen>
        <Carousel
          items={products.results.map((product) => (
            <Box
              key={product.objectID}
              as="a"
              href={`${baseUrl}/sign-in?redirect_to=/product/${product.slug}`}
            >
              <Image key={product.objectID} src={product.image} />
            </Box>
          ))}
          slidesDesktop={6}
          slidesTablet={6}
          slidesMobile={2.5}
          marginSize="m"
        />
      </ContentMobileFullscreen>
      <Box mx={[5, 5, "auto"]} mt={[3, 3, 3, 5]}>
        <Button
          as="a"
          href="/sign-in/"
          variant="primary"
          css={{ margin: "auto" }}
        >
          <Trans>Shop now</Trans>
        </Button>
      </Box>
    </Box>
  ) : null;
};

export default SalesLandingCarousel;
